// import { take, call, put, select, takeLatest } from 'redux-saga/effects';
// import { localActions as actions } from '.';

// function* doSomething() {}

export function* localSaga() {
  // yield takeLatest(actions.someAction.type, doSomething);
}
